module.exports = __webpack_public_path__ + "static/media/599.7554(25).adb5d0bb.pdf";